import { useIsVirtualMarketer } from './useIsVirtualMarketer'

export const useIsSystemRedesign = () => {
  const isVirtualMarketer = useIsVirtualMarketer()
  return isVirtualMarketer
}
